const hasOwn = Object.prototype.hasOwnProperty;
const toString = Object.prototype.toString;
const class2type = (() => {
    const ret = {};
    'Boolean Number String export Function Array Date RegExp Object'
        .split(' ')
        .forEach(name => {
            ret[`[object ${name}]`] = name.toLowerCase();
        });
    return ret;
})();

export function type(obj) {
    return obj === null
        ? String(obj)
        : class2type[toString.call(obj)] || 'object';
}

export function isFunction(obj) {
    return type(obj) === 'function';
}

export function isWindow(obj) {
    return obj !== null && obj === obj.window;
}

export function isPlainObject(obj) {
    if (
        toString.call(obj) !== '[object Object]' ||
        obj.nodeType ||
        isWindow(obj)
    ) {
        return false;
    }
    if (
        obj.constructor &&
        !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')
    ) {
        return false;
    }
    return true;
}

export function isArray(obj) {
    return toString.call(obj) === '[object Array]';
}

export function inArray(array, value) {
    if (!array) {
        return -1;
    }
    const accessor = isFunction(value)
        ? value
        : function(d) {
              return d === value;
          };
    for (let i = 0, l = array.length; i < l; i++) {
        if (accessor(array[i])) {
            return i;
        }
    }
    return -1;
}

/* eslint-disable */
export function extend() {
    let options,
        name,
        src,
        copy,
        copyIsArray,
        clone,
        target = arguments[0] || {},
        i = 1,
        deep = false;

    const length = arguments.length;

    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;

        // Skip the boolean and the target
        target = arguments[i] || {};
        i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== 'object' && !isFunction(target)) {
        target = {};
    }

    for (; i < length; i++) {
        // Only deal with non-null/undefined values
        options = arguments[i];
        if (options !== null) {
            // Extend the base object
            for (name in options) {
                src = target[name];
                copy = options[name];

                // Prevent never-ending loop
                if (target === copy) {
                    continue;
                }

                // Recursion if we're merging plain objects or arrays
                copyIsArray = isArray(copy);
                if (deep && copy && (isPlainObject(copy) || copyIsArray)) {
                    if (copyIsArray) {
                        clone = src && isArray(src) ? src : [];
                    } else {
                        clone = src && isPlainObject(src) ? src : {};
                    }
                    // Never move original objects, clone them
                    target[name] = extend(deep, clone, copy);

                    // Don't bring in undefined values
                } else if (copy !== undefined) {
                    target[name] = copy;
                }
            }
        }
    }

    // Return the modified object
    return target;
}
/* eslint-enable */

export function flattenDeep(arr) {
    return [].concat(
        ...arr.map(v => {
            return isArray(v) ? flattenDeep(v) : v;
        })
    );
}

export function hasProperty(obj, property) {
    return hasOwn.call(obj, property);
}
